import { ArrowUpRight } from "lucide-react";
import { FadeUp, MaskedLines } from "@/components/Reveal";
import { goToAnchor } from "@/lib/scroll";

export default function FreeOffer() {
  return (
    <section data-testid="free-offer-section" className="border-b hairline bg-charcoal/60">
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 py-20 md:py-28 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-8">
          <FadeUp>
            <p className="overline-gold">First time here for real estate photo editing?</p>
          </FadeUp>
          <h2 className="mt-6 font-display font-light text-4xl md:text-5xl lg:text-6xl leading-[1.0] tracking-tight">
            <MaskedLines
              lines={[
                <>
                  TRY YOUR FIRST <em className="text-gold italic">3 PHOTOS</em> FOR FREE.
                </>,
              ]}
            />
          </h2>
          <FadeUp delay={0.25} className="mt-6 max-w-xl">
            <p className="text-sm md:text-base text-ivory/70 font-light leading-relaxed">
              Experience our services at no cost — send three frames from a real shoot
              and discover how we can enhance your photos before you commit to anything.
            </p>
          </FadeUp>
        </div>
        <FadeUp delay={0.2} className="lg:col-span-4 lg:justify-self-end">
          <button
            data-testid="free-offer-cta"
            data-cursor="START"
            onClick={() => goToAnchor("#contact")}
            className="btn-primary"
          >
            Claim 3 Free Edits
            <ArrowUpRight size={14} />
          </button>
          <p className="mt-4 text-[10px] tracking-[0.25em] uppercase text-muted">
            No card. No commitment. Just your photos, perfected.
          </p>
        </FadeUp>
      </div>
    </section>
  );
}
